// extracted by mini-css-extract-plugin
export default {"overlayClass":"Modal_overlayClass__zK6N6","contentClass":"Modal_contentClass__dZ6OT"};